export const BEHAVIOR = { PUSH: 'push', POPIN: 'popin' };
export const VARIANT = { EXPAND: 'expand', SWAP: 'swap' };
export const HEIGHT = { COMPACT: 'compact', UNSET: 'unset' };
